// ESM-Huelle fuer lib/scripts/components/CMP_CLabeledInputField.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CLabeledInputField (id)
{
    this.construct (id);

    this.name = "CLabeledInputField";
    this.htmlType = "div";
    
    this.container = null;
    this.field = null;
    this.label = null;
    this.properties =
    {
        label:
        {
            value: "Input:",
            styles:
            {
                margin: "auto",
                marginRight: "0.1em",
                fontSize: "2.8vh"
            }
        },
        field:
        {
            backspace:
            {
                show: true,
//		backgroundPosition: "center",
//		backgroundSize: "90% 90%",

            },
            clear:
            {
                show: true,
//		backgroundPosition: "center"
	    },
            input:
            {
                type: "all",
                styles:
                {
                    position: "static",
                    margin: "auto"
                },
                attributes: {},
                events: {}
            },
            styles: {}
        },
        styles:
        {
        },
        attributes: {}
    }
}

CLabeledInputField.prototype = new CComponent;

CLabeledInputField.prototype.prepare = function ()
{
    this.container = this.addChild (CContainerTable);
    this.container.properties.rows = 1;
    this.container.properties.columns = 2;
    this.container.prepare ();
    
    this.field = this.container.body.rows[0].columns[1].addChild (CInputField);
    this.field.properties = combine (this.field.properties, this.properties.field);
    //this.field.properties = combine (this.properties.field,this.field.properties);
    if (this.field.properties.styles && typeof this.field.properties.styles.width != "undefined")
        this.container.body.rows[0].columns[1].properties.styles.width =
            this.field.properties.styles.width;
    
    this.label = this.container.body.rows[0].columns[0].addChild (CCaption);
    this.label.properties = combine (this.label.properties, this.properties.label);
	//this.label.properties = combine (this.properties.label,this.label.properties);
    if (this.label.properties.styles && typeof this.label.properties.styles.width != "undefined")
        this.container.body.rows[0].columns[0].properties.styles.width =
            this.label.properties.styles.width;
    this.container.body.rows[0].columns[0].properties.styles.text_align = "right";

    this.prepared = true;
}

CLabeledInputField.prototype.setEnabled = function(bool)
{
    this.label.setEnabled(bool);
    this.field.setEnabled(bool);
}

export { CLabeledInputField };
